module.exports = __webpack_public_path__ + "static/media/gcalendar_image.d84c03a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gcalendar_image.png
// module id = 77
// module chunks = 0